import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Brain, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-kopf-secondary/10 to-kopf-white">
      <div className="text-center max-w-md px-6">
        <div className="mb-6 inline-flex items-center justify-center w-20 h-20 rounded-full bg-kopf-accent/20">
          <Brain className="w-10 h-10 text-kopf-primary" />
        </div>
        
        <h1 className="mb-3 text-6xl font-bold text-kopf-primary">404</h1>
        <h2 className="mb-4 text-2xl font-semibold text-kopf-text">Página não encontrada</h2>
        <p className="mb-8 text-kopf-text/60 leading-relaxed">
          Parece que você se perdeu no universo do bem-estar mental. 
          Não se preocupe, estamos aqui para te guiar de volta ao blog!
        </p>
        
        <Button asChild className="bg-kopf-primary hover:bg-kopf-primary/90 text-white">
          <Link to="/">
            <Home className="w-4 h-4 mr-2" />
            Voltar ao Blog
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
